<script>
const sidebarMenu = [
  // { icon : 'fa fa-chart-bar' , title : 'National Report' , path : '/national-reports' },

  //Dashboard
  {
    icon: "li",
    title: "Dashboard",
  },
  { icon: "fa fa-chart-bar", title: "Highlights", path: "/highlight", access: "All" },

  //H1
  {
    path: "/h1",
    icon: "fas fa-chart-area",
    title: "H1 - Sales",
    children: [
      {
        path: "/h1/qr-registration",
        title: "QR Registration",
        children: [
          { path: "/h1/qr-registration/daily", title: "Daily", access: "All" },
          { path: "/h1/qr-registration/monthly", title: "Monthly", access: "All" },
        ],
      },
      {
        path: "/h1/stock-details",
        title: "Stock Details",
        children: [
          { path: "/h1/stock-details/stock-availability", title: "Stock Availability", access: "All" },
          { path: "/h1/stock-details/stock-in-transit", title: "Stock In Transit", access: "All" },
          { path: "/h1/stock-details/average-days-of-stock", title: "Average Days Of Stock", access: "All" },
          { path: "/h1/stock-details/aging-stock", title: "Aging Stock", access: "All" },
        ],
      },
      {
        path: "/h1/sales",
        title: "Sales",
        children: [
          { path: "/h1/sales/regional-sales", title: "Regional Sales", access: "All" },
          { path: "/h1/sales/retail-sales", title: "Retail Sales", access: "All" },
        ],
      },
      {
        path: "/h1/warehouse-behavior",
        title: "Warehouse Behavior",
        children: [
          {
            path: "/h1/warehouse-behavior/incoming",
            title: "Incoming",
            access: "All",
          },
          {
            path: "/h1/warehouse-behavior/outgoing",
            title: "Outgoing",
            access: "All",
          },
        ],
      },
      { path: "/h1/lead-time-delivery", title: "Lead Time Penerimaan Dealer", access: "All" },
      { path: "/h1/customer-location", title: "Customer Location", access: "All" },
      { path: "/h1/vehicle-deviation", title: "Vehicle Deviation", access: "All" },
      { path: "/h1/expedition-monitoring", title: "Expedition Monitoring", access: "All" },
      { path: "/h1/logistic-partner", title: "Logistic Partner", access: "All" },
      { path: "/h1/trend-sales", title: "Trend Sales", access: "All" },
      { path: "/h1/mcd-report", title: "Target Sales Kecamatan", access: "All" },
    ],
  },

  //H2
  {
    path: "/h2",
    icon: "fa fa-chart-line",
    title: "H2 - Service",
    children: [
      { path: "/h2/qr-registration", title: "QR Registration", access: "All" },
      { path: "/h2/replaced-qr", title: "Unmatched QR", access: "All" },
      { path: "/h2/change-ownership", title: "Change Ownership", access: "All" },
      { path: "/h2/service-cycle", title: "Service Cycle", access: "All" },
      { path: "/h2/workshop-traffic", title: "Workshop Traffic", access: "All" },
    ],
  },

  //Reports
  {
    path: "/report",
    icon: "fas fa-clipboard-list",
    title: "Reports",
    children: [
      { path: "/report/h1-report", title: "H1 Report", access: "All" },
      { path: "/report/h2-report", title: "H2 Report", access: "All" },
      { path: "/report/summary-qr", title: "Summary QR Registration", access: "All" },
      { path: "/report/summary-document-data", title: "Summary Document Data", access: "All" },
      { path: "/report/vehicle-search", title: "Vehicle Search", access: "All" },
      { path: "/report/qrcode", title: "QR Code", access: "All" },
      { path: "/report/report-download", title: "Download Report", access: "All" },
      { path: "/report/qrcode-replacement", title: "QR Code Unmatched", access: "All" },
      { path: "/report/change-ownership", title: "Change Ownership", access: "All" },
      { path: "/report/customer", title: "Customer", access: "All" },
      { path: "/report/dealer-delivery", title: "Territory Report", access: "All" },
      { path: "/report/summary-api-log", title: "Summary API Log", access: "All" },
      // { path : '/report/log-report' ,title : 'API Log Report', access:'All'},
    ],
  },

  //QR Codes
  {
    path: "/qr-code",
    icon: "fas fa-qrcode",
    title: "QR Codes",
    children: [
      { path: "/qr-code/distribution-monitoring", title: "Distribution Monitoring" },
      { path: "/qr-code/qr-issue", title: "QR Issue" },
      { path: "/qr-code/qr-receipt", title: "QR Receipt" },
      { path: "/qr-code/dealer-used", title: "QR Used by Dealer" },
      { path: "/qr-code/transfer-amount-setting", title: "Atur Jumlah Transfer QR" },
      { path: "/qr-code/return-transfer-access", title: "Atur Akses Transfer Balik" },
    ],
  },

  //Settings
  {
    path: "/setting",
    icon: "fas fa-cog",
    title: "Settings",
    children: [
      { path: "/setting/user-management", title: "User Management", access: "All" },
      { path: "/setting/target", title: "Target", access: "All" },
      { path: "/setting/dealer-radius", title: "Dealer Radius", access: "All" },
      { path: "/setting/calendar", title: "Calendar", access: "All" },
      { path: "/setting/mcd-target", title: "Target Sales Report", access: "All" },
      { path: "/setting/service-lost", title: "Service Lost Settings", access: "All" },
    ],
  },
];

export default sidebarMenu;
</script>
